module.exports = __webpack_public_path__ + "img/rank_list_bg@2x.16e8e833.png";